import React, { Component } from 'react'
import PropTypes from 'prop-types'
import validate from 'validate.js'
import { authActions } from 'modules/auth/index'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { SIGN_IN_PATH } from 'config'
import AuthAlerts from 'components/auth/auth-alerts'

import ValidatedInput from 'components/common/validated-input'


const constraints = {
  email: {
    presence: { message: 'Email is required' },
    email: { message: 'Email is not valid' },
  },
};

export class Password extends Component {
  static propTypes = {
    resetPassword: PropTypes.func.isRequired,
  }

  state = {
    submitted: false,
    error: '',
  }

  onSubmit = (event) => {
    event.preventDefault();
    const email = this.email ? this.email.value : '';

    this.setState({ error: null }, () => {
      const errors = validate({ email }, constraints, { fullMessages: false });

      if (errors && errors.email.length) {
        this.setState({ error: errors.email[0] });
      } else {
        this.props
          .resetPassword(email)
          .then(() => {
            debugger;
          })
          .catch(() => {
            debugger;
          })
      }
    })
  }

  getEmailRef = (node) => {
    this.email = node;
  }

  render() {
    return (
      <div className="center-block auth-form__container auth-form__container--password">
        <div className="auth-form">
          <AuthAlerts/>
          <div className="card card-block mb-3">
            <form role="form" onSubmit={ this.onSubmit } noValidate>
              <h2>Reset your password</h2>
              <div className="form-group text-left">
                <ValidatedInput errorText={ this.state.error }>
                  { ({ inputClassName, errorNode }) => {
                    return (
                      <span>
                        <input className={ inputClassName }
                               id="email"
                               name="email"
                               placeholder="Email"
                               type="email"
                               ref={ this.getEmailRef }/>
                        { errorNode }
                      </span>
                    )
                  } }
                </ValidatedInput>
              </div>
              <button className="btn btn-primary" type="submit">
                Send me password reset instructions
              </button>
            </form>
          </div>
          <p>I remembered! <Link to={ SIGN_IN_PATH }>Let me sign in</Link></p>
        </div>
      </div>
    )
  }
}

export default connect(state => ({ ...state.auth }), authActions)(Password)



// WEBPACK FOOTER //
// ./src/components/auth/password/password.js